import { AjvError } from "@rjsf/core";

export function transformErrorsToFinnish(errors: AjvError[]): AjvError[] {
    return errors.map(error => {
        //  console.info({ error });
        if (error.name === "required") {
            error.message = "Pakollinen kenttä";
        }

        if (error.name === "maxLength") {
            error.message = `Ei tulisi olla pidempi kuin ${error.params.limit} merkkiä`;
        }

        if (error.name === "minLength") {
            error.message = `Ei tulisi olla lyhyempi kuin ${error.params.limit} merkkiä`;
        }

        if (error.name === "minItems") {
            error.message = "Valitse vähintään " + error.params.limit
        }

        if (error.name === "format") {
            //    console.info("[transformErrors.format]", error.params);

            if (error.params.format === "date-time") {
                error.message = "Päivämäärän tulee olla muodossa pp.kk.vvvv HH:mm";
            }
            if (error.params.format === "time") {
                error.message = "Kellonaika ei ole okeassa muodossa";
            }
            if (error.params.format === "date") {
                error.message = "Päivämäärän tulee olla muodossa pp.kk.vvvv";
            }
        }



        return error;
    });
}

